import { render, staticRenderFns } from "./UpdateMlbbMmr.vue?vue&type=template&id=cb75e942&scoped=true"
import script from "./UpdateMlbbMmr.vue?vue&type=script&lang=js"
export * from "./UpdateMlbbMmr.vue?vue&type=script&lang=js"
import style0 from "./UpdateMlbbMmr.vue?vue&type=style&index=0&id=cb75e942&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb75e942",
  null
  
)

export default component.exports